
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('inicio')}>
            <img
              src="https://static.readdy.ai/image/6ae913d34dc5289e66b9f22e1ec27e15/22c22442c4d57f6bf0d57c097e0b2690.jpeg"
              alt="Talleres Lujambio"
              className="h-24 w-auto object-contain"
            />
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('inicio')}
              className="text-sm font-medium transition-colors whitespace-nowrap hover:text-teal-600 text-gray-800"
            >
              Inicio
            </button>
            <button
              onClick={() => scrollToSection('proyectos')}
              className="text-sm font-medium transition-colors whitespace-nowrap hover:text-teal-600 text-gray-800"
            >
              Proyectos
            </button>
            <button
              onClick={() => scrollToSection('sobre-nosotros')}
              className="text-sm font-medium transition-colors whitespace-nowrap hover:text-teal-600 text-gray-800"
            >
              Sobre Nosotros
            </button>
            <button
              onClick={() => scrollToSection('galeria')}
              className="text-sm font-medium transition-colors whitespace-nowrap hover:text-teal-600 text-gray-800"
            >
              Galería
            </button>
            <button
              onClick={() => scrollToSection('contacto')}
              className="bg-teal-600 text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-teal-700 transition-colors whitespace-nowrap"
            >
              Contacto
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl text-gray-800`}></i>
            </div>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-3">
            <button
              onClick={() => scrollToSection('inicio')}
              className="block w-full text-left text-sm font-medium text-gray-800 hover:text-teal-600 py-2"
            >
              Inicio
            </button>
            <button
              onClick={() => scrollToSection('proyectos')}
              className="block w-full text-left text-sm font-medium text-gray-800 hover:text-teal-600 py-2"
            >
              Proyectos
            </button>
            <button
              onClick={() => scrollToSection('sobre-nosotros')}
              className="block w-full text-left text-sm font-medium text-gray-800 hover:text-teal-600 py-2"
            >
              Sobre Nosotros
            </button>
            <button
              onClick={() => scrollToSection('galeria')}
              className="block w-full text-left text-sm font-medium text-gray-800 hover:text-teal-600 py-2"
            >
              Galería
            </button>
            <button
              onClick={() => scrollToSection('contacto')}
              className="block w-full text-left bg-teal-600 text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-teal-700 transition-colors"
            >
              Contacto
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}
